module.exports = __webpack_public_path__ + "static/media/cy.f0e26651.svg";